import { Button, Checkbox, CityState, DataSource, Image, Label, Layout, Panel, Repeater, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommChat extends Layout {
    buttonAttachment: Button;
    buttonConfirm: Button;
    buttonInboundFilter: Button;
    buttonOutboundFilter: Button;
    buttonSend: Button;
    checkboxConfirmedSelectAll: Checkbox;
    citystateDest: CityState;
    citystateOrigin: CityState;
    imageStatus: Image;
    labelTo: Label;
    panelFilters: Panel;
    panelMessage: Panel;
    panelMovementInfo: Panel;
    panelSearchBox: Panel;
    panelSecondaryFilters: Panel;
    panelToolbar: Panel;
    panelUnitInfo: Panel;
    repeaterChats: Repeater;
    sourceMcMessage: DataSource;
    sourceMcMessageAdd: DataSource;
    sourceMovementEquipment: DataSource;
    textboxDriver2: Textbox;
    textboxDriver: Textbox;
    textboxMcUnitNo: Textbox;
    textboxMessage: Textbox;
    textboxTractorid: Textbox;
}
